export enum MessageType {
  REPOSITORIES_UPDATED = 'repositoriesUpdated',
}
